import { dsClass } from '../../common/constants/dsClasses';
import { confirmMsg, t } from '../../common/i18n';
import { ConfirmationDialog } from '../ConfirmationDialog';
import {
  ActivationInfo,
  AddedAddOns,
  PaymentInfo,
  RemovalInfo,
  RemovedAddOns,
  TotalChangeFee,
} from '../SubscriptionDetails/AddOnChangeConfirmationDialogContent';
import type { AddOn } from '../../generated/api/addOn';

interface AddonConfirmationDialogProps {
  addedAddOns: AddOn[];
  removedAddOns: AddOn[];
  isEmployee: boolean;
  updatedPrice?: number;
  serviceFee?: number;
  onCloseDialog: () => void;
  onConfirm: () => void;
  isSaving: boolean;
}

export const AddonConfirmationDialog = ({
  addedAddOns,
  removedAddOns,
  isEmployee,
  updatedPrice,
  serviceFee,
  onCloseDialog,
  onConfirm,
  isSaving,
}: AddonConfirmationDialogProps) => {
  const body = (
    <div
      className={`of-addon-change-confirmation-dialog of-addon-change-confirmation-dialog__border-top ${dsClass.MARGIN_TOP_2}`}
    >
      <AddedAddOns addedAddOns={addedAddOns} isEmployee={isEmployee} />
      <RemovedAddOns removedAddOns={removedAddOns} isEmployee={isEmployee} />
      <TotalChangeFee serviceFee={serviceFee} isEmployee={isEmployee} />
      <PaymentInfo updatedPrice={updatedPrice} isEmployee={isEmployee} />
      <RemovalInfo removedAddOns={removedAddOns} isEmployee={isEmployee} />
      <ActivationInfo />
    </div>
  );

  return (
    <ConfirmationDialog
      body={<div>{body}</div>}
      confirmButtonText={t.QVYK(confirmMsg)}
      header={t.LYSP('Service changes')}
      hideClosingCross={false}
      isLoading={isSaving}
      onCloseDialog={onCloseDialog}
      onConfirm={onConfirm}
    />
  );
};
